import _get from 'lodash/get'
import { z } from 'zod'

import { CONTENTS_NXT_CONSTANTS } from '@flows/configs/contentsNxt/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { FlowValues, SubmitHookResult } from '@flows/core/types/stepTypes'

export const validateBikeInsuredSum =
  (params: StepConfigParams) =>
  (formValues: FlowValues): SubmitHookResult => {
    const constants = CONTENTS_NXT_CONSTANTS
    /**
     * This callback will update the input price of the bike
     * The price can't be below 500 and over 5000
     */
    const bikeInsuredSumResult = z.coerce
      .string()
      .safeParse(
        _get(formValues, params.helperFunctions.getParamPath('bike_theft_insured_sum_amount'))
      )

    const insured_sum_confirmation = _get(
      formValues,
      params.helperFunctions.getHelperPath('insured_sum_confirmation')
    )

    if (insured_sum_confirmation === false) {
      return {
        formValues: {
          [params.helperFunctions.getParamPath('bike_theft_coverage')]: false,
          [params.helperFunctions.getParamPath('bike_theft_insured_sum_amount')]: null,
          [params.helperFunctions.getHelperPath('insured_sum_confirmation')]: null,
          [params.helperFunctions.getHelperPath('insured_sum_show_confirmation')]: null,
        },
      }
    }

    if (!bikeInsuredSumResult.success) {
      throw new Error('Assertion: Bike insured sum is undefined')
    }

    const bikeInsuredSum = bikeInsuredSumResult.data

    if (
      bikeInsuredSum === '' ||
      Number.parseInt(bikeInsuredSum) < constants.insuredSumBikeValidation.min
    ) {
      return {
        formValues: {
          [params.helperFunctions.getHelperPath('insured_sum_show_confirmation')]: true,
          [params.helperFunctions.getParamPath('bike_theft_insured_sum_amount')]:
            constants.insuredSumBikeValidation.min,
        },
        error: {
          type: 'translatableText',
          translationKey:
            'sharedFlows_contentsNxt:steps.contents_bike_insured_sum.errors.insured_sum',
        },
      }
    }

    if (Number.parseInt(bikeInsuredSum) > constants.insuredSumBikeValidation.max) {
      return {
        formValues: {
          [params.helperFunctions.getHelperPath('insured_sum_show_confirmation')]: true,
          [params.helperFunctions.getParamPath('bike_theft_insured_sum_amount')]:
            constants.insuredSumBikeValidation.max,
        },
        error: {
          type: 'translatableText',
          translationKey:
            'sharedFlows_contentsNxt:steps.contents_bike_insured_sum.errors.insured_sum',
        },
      }
    }

    return {
      formValues: {
        [params.helperFunctions.getParamPath('bike_theft_coverage')]: true,
        [params.helperFunctions.getHelperPath('insured_sum_show_confirmation')]: null,
      },
    }
  }
